import { useState } from 'react';
import { cn } from '@/lib/utils';

const LOGO_SOURCES = ['/Textlogo.png', '/logo.png', '/logo.svg'] as const;

type ArcadiaHeaderLogoProps = {
  className?: string;
  /** Height of the logo mark (width follows aspect ratio). */
  heightClass?: string;
};

/**
 * Brand mark: tries bundled wordmarks / PNG / SVG from `public/`, then text fallback.
 * Matches the legacy Next header behavior.
 */
export function ArcadiaHeaderLogo({ className, heightClass = 'h-8' }: ArcadiaHeaderLogoProps) {
  const [index, setIndex] = useState(0);

  if (index >= LOGO_SOURCES.length) {
    return (
      <span
        className={cn(
          'font-display text-2xl font-bold tracking-tighter text-transparent bg-gradient-to-r from-blue-400 to-blue-200 bg-clip-text',
          className,
        )}
      >
        Arcadia
      </span>
    );
  }

  return (
    <img
      src={LOGO_SOURCES[index]}
      alt="Arcadia"
      width={140}
      height={32}
      className={cn('w-auto object-contain object-left', heightClass, className)}
      onError={() => setIndex((i) => i + 1)}
    />
  );
}
